var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pt-0 mt-0"},[_c('v-row',[_c('v-spacer'),_c('v-col',{attrs:{"cols":"10"}},[_c('user-form')],1),_c('v-spacer')],1),_c('v-row',[_c('v-spacer'),_c('v-col',{attrs:{"cols":"10"}}),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }